export default {"src":"/_next/static/media/hightlighteducators.10c569cd.svg","height":180,"width":284};